export default __webpack_public_path__ + "static/media/cx_cover_tln3s.ba739dd2.jpg";